import script from "./MotionBank.vue?vue&type=script&setup=true&lang=js"
export * from "./MotionBank.vue?vue&type=script&setup=true&lang=js"

import "./MotionBank.vue?vue&type=style&index=0&id=d0596a12&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0596a12"]])

export default __exports__